import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesPlusFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 3.25 2.375 2 12 2s11 1.25 11 10q0 .784-.016 1.489a6.8 6.8 0 0 0-10.09 8.507Q12.459 22 12 22C2.375 22 1 20.75 1 12m5-4.9v1.8h12V7.1zm0 5.8h6v-1.8H6z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10m-.9-8v2.1H16v1.8h2.1V22h1.8v-2.1H22v-1.8h-2.1V16z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesPlusFilledSize24Glyph.displayName = 'CardLinesPlusFilledSize24Glyph';
